export const gapiConfig = {
  apiKey: process.env.API_GOOGLE_APIKEY ?? '',
  discoveryDocs: [
    'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
  ],
}
